  document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth > 767) return;

  new Swiper(".icon-features-slider", {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    }
  });

});